import { c as _c } from "react/compiler-runtime";
import { allCreditSubscriptionsSelector, fetchingSdbCompanyFlagsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { isFeatureAvailableInCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { useEffect, useState } from "react";
/** Custom hook to determine if the "Add Credits" button and add credits page should be shown */
export function useShouldShowAddCredits() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = isFeatureAvailableInCompanySelector("floorplan-generator");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isFloorplanGeneratorFeatureEnabled = useAppSelector(t0);
  const {
    fetchSelectedCompanyContext,
    fetchCompanySubscriptions
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const isFetchingCompanySubscriptions = fetchCompanySubscriptions === "pending";
  const creditSubscriptions = useAppSelector(allCreditSubscriptionsSelector);
  const [shouldShowAddCredits, setShouldShowAddCredits] = useState(true);
  let t1;
  let t2;
  if ($[1] !== creditSubscriptions.length || $[2] !== fetchSelectedCompanyContext || $[3] !== isFetchingCompanySubscriptions || $[4] !== isFloorplanGeneratorFeatureEnabled) {
    t1 = () => {
      if (fetchSelectedCompanyContext === "succeeded" && !isFetchingCompanySubscriptions) {
        setShouldShowAddCredits(isFloorplanGeneratorFeatureEnabled || creditSubscriptions.length > 0);
      }
    };
    t2 = [isFloorplanGeneratorFeatureEnabled, fetchSelectedCompanyContext, creditSubscriptions.length, isFetchingCompanySubscriptions];
    $[1] = creditSubscriptions.length;
    $[2] = fetchSelectedCompanyContext;
    $[3] = isFetchingCompanySubscriptions;
    $[4] = isFloorplanGeneratorFeatureEnabled;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== shouldShowAddCredits) {
    t3 = {
      shouldShowAddCredits
    };
    $[7] = shouldShowAddCredits;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}